//#region imports
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ProgressBarService } from 'src/app/services/progressbar.service';
import { CharacteristicService } from '../services/characteristic.service';
import { CharacteristicsComponentModel } from '../module/characteristics/components/characteristics.model';
import { GuaranteeService } from '../services/guarantee.service';
import { GuaranteeComponentModel } from '../module/guarantee/model/tarif.model';
import { DetailsService } from '../services/details.service';
import { DetailsComponentModel } from '../module/details/details.model';
import { SignatureComponentModel } from '../module/signature/model/signature.model';
import { SignatureService } from '../services/signature.service';
import { MatChipSelectionChange } from '@angular/material';
import { Globals } from '../services/globals';
import { SectionService } from '../services/section.service';
import { SummaryService } from '../services/summary.service'
//#endregion

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  //#region variables
  disable1 = false;
  disable2 = true;
  disable3 = true;
  disable4 = true;
  disable5 = true;

  number1 = false;
  number2 = true;
  number3 = true;
  number4 = true;
  number5 = true;

  icon1 = false;
  icon2 = false;
  icon3 = false;
  icon4 = false;
  icon5 = false;
  characteristicsComponent: CharacteristicsComponentModel;
  detailsComponent: DetailsComponentModel;
  guaranteeComponent: GuaranteeComponentModel;
  signatureComponent: SignatureComponentModel;

  enable1 = true;
  enable2 = false;
  enable3 = false;
  enable4 = false;
  enable5 = false;
  showNormalTitle = true;
  premiumTotalAmount: string;
  abexValue: string;
  //#endregion

  // @ViewChild(CharacteristicsQuestionComponent) characteristicsQuestion: CharacteristicsQuestionComponent;

  //#region methods
  constructor(
    private progressBarService: ProgressBarService, private characteristicService: CharacteristicService,
    private detailsService: DetailsService, private guaranteeService: GuaranteeService,
    private signatureService: SignatureService, private changeDetectorRef: ChangeDetectorRef, 
    private globals: Globals, private sectionService: SectionService,
    private summaryService: SummaryService) { }

  ngOnInit() {
    this.progressBarService.getCharacteristicsProgressStatus().subscribe((data) => {
      this.disable1 = data.Disable;
      this.number1 = data.Number;
      this.icon1 = data.Icon;
    });
    this.progressBarService.getDetailsProgressStatus().subscribe((data) => {
      this.disable2 = data.Disable;
      this.number2 = data.Number;
      this.icon2 = data.Icon;
      
    });
    this.progressBarService.getGauranteeProgressStatus().subscribe((data) => {
      this.disable3 = data.Disable;
      this.number3 = data.Number;
      this.icon3 = data.Icon;
      
    });
    this.progressBarService.getSummaryProgressStatus().subscribe((data) => {
      this.disable4 = data.Disable;
      this.number4 = data.Number;
      this.icon4 = data.Icon;
    
    });
    this.progressBarService.getSignatureProgressStatus().subscribe((data) => {
      this.disable5 = data.Disable;
      this.number5 = data.Number;
      this.icon5 = data.Icon;
      
    });
    //#Mobile
    this.progressBarService.getmobileCharacteristicsProgressStatus().subscribe((data) => {
      this.enable1 = data.Enable;
    });
    this.progressBarService.getmobileDetailsProgressStatus().subscribe((data) => {
      this.enable2 = data.Enable;
    });
    this.progressBarService.getmobileGauranteeProgressStatus().subscribe((data) => {
      this.enable3 = data.Enable;
    });
    this.progressBarService.getmobileSummaryProgressStatus().subscribe((data) => {
      this.enable4 = data.Enable;
    });
    this.progressBarService.getmobileSignatureProgressStatus().subscribe((data) => {
      this.enable5 = data.Enable;
    });
    //#endregion Mobile


    // const isRetrieveSimulation = this.sectionService.getIsRetrieveSimulation();
    // if (isRetrieveSimulation) {
    //   this.guaranteeService.setGuaranteeProgressBarDetails();
    //   if(this.globals.isMobile)
    //   {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    //   this.sectionService.setIsRetrieveSimulation(false);
    // }
    // const guaranteeFromRecapitulatory = this.guaranteeService.getGuaranteeFromRecapitulatory();
    // this.guaranteeService.getGuaranteeComponent().subscribe((value) => {
    //   this.guaranteeComponent = value;
    // });
    // if (!this.guaranteeComponent) {
    //   if (!guaranteeFromRecapitulatory) {
    //     this.guaranteeComponent = {
    //       GuaranteeQuestion1: true, GuaranteeQuestion2: false, GuaranteeQuestion3: false,
    //       GuaranteeQuestion4: false, GuaranteeQuestion5: false
    //     };
    //   } else {
    //     this.guaranteeComponent = {
    //       GuaranteeQuestion1: false, GuaranteeQuestion2: false, GuaranteeQuestion3: false,
    //       GuaranteeQuestion4: false, GuaranteeQuestion5: true
    //     };
    //     this.premiumTotalAmount = this.guaranteeService.getInitialPricingData().Tarification.Premium_Total_Amount;
    //   }
    //   this.guaranteeService.setGuaranteeComponent(this.guaranteeComponent);
    // }
    // this.globals.guaranteeHeader1 = false;
    // this.globals.guaranteeHeader2 = false;
    // this.guaranteeService.getPremiumTotalAmount().subscribe((value) => {
    //   this.premiumTotalAmount = value;
    // });
    // this.abexValue = this.globals.abexValueGlobal;
  }

  // ngAfterContentChecked() {
  //   this.guaranteeService.getshowNormalTitle().subscribe((value) => {
  //     this.showNormalTitle = value;
  //   });
  //   this.changeDetectorRef.detectChanges();
  //   this.abexValue = this.globals.abexValueGlobal;
  // }
  scrollToView(id){
    // var top = document.getElementById(id).offsetTop-document.getElementById("nav").offsetHeight;
    // window.scrollTo(0, top);
    setTimeout(()=>{
      var element = document.getElementById(id);
      if (element !== null && element !== undefined)  
      {
        if(element.classList.value == "panel disabledSection panel-open"){
          element.classList.remove("disabledSection")
        }
        var top = document.getElementById(id).offsetTop-document.getElementById("nav").offsetHeight;
        window.scrollTo(0, top);
      }
    }, 500);
    // if(id == "tab1"){
    //   this.btnCharacteristics();
    // }else if(id == "tab2"){
    //  this.btnDetails();
    // }else if(id == "tab3"){
    //  this.btnGuarantee();
    // }else if(id == "tab4"){
    //   this.btnRecapitulatory();
    // }else if(id == "tab5"){
    //   this.btnSignature();
    // }
  }


  btnCharacteristics() { 
    if(this.globals.isMobile)
      {
        this.enable1 = true;
        this.enable2 = this.enable3 = this.enable4 = this.enable5 =false;
        document.getElementById("tab3").querySelector(".panel-heading").classList.remove("show-banner");
        document.getElementById("tab4").querySelector(".panel-heading").classList.remove("show-banner");
      }     
    this.characteristicService.setShowPrevious(false);
    this.characteristicsComponent = {
      Question1: true, Question2: false, Question3: false, Question4: false, Question5: false
    };
    this.characteristicService.setCharacteristicsComponent(this.characteristicsComponent);
  }

  btnDetails() {
    if(this.globals.isMobile)
      {
        this.enable2 = true;
        this.enable1 = this.enable3 = this.enable4 = this.enable5 =false;
        document.getElementById("tab3").querySelector(".panel-heading").classList.remove("show-banner");
        document.getElementById("tab4").querySelector(".panel-heading").classList.remove("show-banner");
      }
    const detailsSection = this.detailsService.getDetailsSection();
    if (detailsSection === 'S2.1') {
      this.detailsComponent = {
        DetailsQuestion1: true, DetailsQuestion2: false, DetailsQuestion3: false,
        DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
        DetailsQuestion7: false, DetailsQuestion8: false, DetailsQuestion9: false,
        DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
      };
    } else {
      this.detailsComponent = {
        DetailsQuestion1: false, DetailsQuestion2: false, DetailsQuestion3: false,
        DetailsQuestion4: false, DetailsQuestion5: false, DetailsQuestion6: false,
        DetailsQuestion7: true, DetailsQuestion8: false, DetailsQuestion9: false,
        DetailsQuestion10: false, DetailsQuestion11: false, DetailsQuestion12: false
      }; 
    }
    this.detailsService.setDisableDetailsNext(false);
    this.detailsService.setDetailsComponent(this.detailsComponent);
  }

  btnGuarantee() {
    if(this.globals.isMobile)
      {
        this.enable3 = true;
        this.enable2 = this.enable1 = this.enable4 = this.enable5 =false;
        document.getElementById("tab3").querySelector(".panel-heading").classList.add("show-banner");
        document.getElementById("tab4").querySelector(".panel-heading").classList.remove("show-banner");
      }  
    this.guaranteeComponent = {
      GuaranteeQuestion1: true, GuaranteeQuestion2: false, GuaranteeQuestion3: false,
      GuaranteeQuestion4: false, GuaranteeQuestion5: false
    };
    this.guaranteeService.setGuaranteeComponent(this.guaranteeComponent);
    if (this.guaranteeService.getInitialPricingData()) {
      if (!this.guaranteeService.getContentCovering()) {
        this.guaranteeService.setContentCovering(false);
      }
    }
  }

  btnRecapitulatory(){
    if(this.globals.isMobile)
      {
        this.enable4 = true;
        this.enable2 = this.enable3 = this.enable1 = this.enable5 =false;
        document.getElementById("tab4").querySelector(".panel-heading").classList.add("show-banner");
        document.getElementById("tab3").querySelector(".panel-heading").classList.remove("show-banner");
      }  
  }

  btnSignature() {
    if(this.globals.isMobile)
      {
        this.enable5 = true;
        this.enable2 = this.enable3 = this.enable4 = this.enable1 =false;
        document.getElementById("tab4").querySelector(".panel-heading").classList.remove("show-banner");
        document.getElementById("tab3").querySelector(".panel-heading").classList.remove("show-banner");
      }
    this.signatureComponent = {
      SignatureQuestion1: true, SignatureQuestion2: false, SignatureQuestion3: false,
      SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse: false
    };
    this.signatureService.setShowSignaturePrevious(false);
    this.signatureService.setShowSignatureNext(true);
    this.signatureService.setSignatureComponent(this.signatureComponent);
  }
  //#endregion
}
